import Menu from '~/shared/components/header/components/menu';
import Link from '~/shared/components/link';
import { TabletDesktopMedia } from '~/shared/components/media-query';
import ThemedLogo from '~/shared/components/themed-logo';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getDeviceInfo } from '~/shared/helpers/get-device-info';
import type { ShortUserType } from '~/shared/types/user-type';

import './main-menu.scss';

type MainMenuProps = Readonly<{
  lng: Locale;
  user: ShortUserType | null;
  isClientsPanel?: boolean;
  isAdminPanel?: boolean;
  isPlatform?: boolean;
  hideNavigation?: boolean;
}>;

const MainMenu = ({
  isClientsPanel = false,
  isAdminPanel = false,
  isPlatform = false,
  hideNavigation = false,
  user,
  lng,
}: MainMenuProps) => {
  const device = getDeviceInfo();

  return (
    <div className="main-menu" itemScope itemType="https://schema.org/Organization">
      {isClientsPanel || isAdminPanel || isPlatform ? (
        <ThemedLogo priority itemProp="logo" alt="prana-club-logo" className="main-menu__logo" />
      ) : (
        <Link itemProp="url" className="main-menu__logo-link" href={getLocaleLink(PAGE_NAMES.HOME, lng)}>
          <ThemedLogo priority itemProp="logo" alt="prana-club-logo" className="main-menu__logo" />
        </Link>
      )}

      {/*{device.isMobileDevice && (*/}
      {isPlatform && (
        <>
          <div id="online-course-tools-portal" className="main-menu__tools-portal" />
          <div id="online-course-video-ribbon-portal" className="main-menu__video-ribbon-portal" />
        </>
      )}
      {/* )}*/}

      {!device.isMobileDevice && !hideNavigation && (
        <TabletDesktopMedia>
          <Menu
            isClientsPanel={isClientsPanel}
            isAdminPanel={isAdminPanel}
            isPlatform={isPlatform}
            user={user}
            lng={lng}
          />
        </TabletDesktopMedia>
      )}
    </div>
  );
};

export default MainMenu;
